var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7d00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Icons_-_192dp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pit_icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,42a10.73,10.73,0,0,1-2.26,4.12C115.67,50,102.63,62.5,64.9,62.5v8H96.45C91.78,78,80.14,91,55.4,91v8H69.89c-1.06,4.48-4.35,11-14.49,11H30.9V66.58C31.1,65.25,35.89,42.16,121,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140,0H12A12,12,0,0,0,0,12V140a12,12,0,0,0,12,12H140a12,12,0,0,0,12-12V12A12,12,0,0,0,140,0ZM113.74,60.26a57.76,57.76,0,0,1-5.45,2.7l-1.6,4.8A44.7,44.7,0,0,1,96.22,83.58,50.58,50.58,0,0,1,78.4,95c0,8-4.83,23-23,23H22.9V66.5c0-3.33,2.77-32.5,99-32.5a7,7,0,0,1,7.21,7.39C129.11,46.33,125.07,53.88,113.74,60.26Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitIcon);
export default __webpack_public_path__ + "static/media/pit_icon.8aecf32d49ede10f06a3ff586a5bb8f7.svg";
export { ForwardRef as ReactComponent };